module.exports = __webpack_public_path__ + "assets/img/27_1457.b84d655a.jpg";